import { render, staticRenderFns } from "./KsCollapse.vue?vue&type=template&id=117fe784"
import script from "./KsCollapse.vue?vue&type=script&lang=js"
export * from "./KsCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports